module.exports = __webpack_public_path__ + "img/no-method.a3d1d7f8.png";